/**
 * Animate numbers from start to end in specific time
 * @param {number} from
 * @param {number} to
 * @param {number} duration
 * @param {(value: number) => void} onUpdate
 */
function animateValue(from, to, duration, onUpdate) {
	let startTimestamp = null;
	const step = (timestamp) => {
		if (!startTimestamp) startTimestamp = timestamp;
		const progress = Math.min((timestamp - startTimestamp) / duration, 1);

		const value = progress * (to - from) + from;
		if (onUpdate instanceof Function) {
			onUpdate(value, progress);
		}

		if (progress < 1) {
			window.requestAnimationFrame(step);
		}
	};
	window.requestAnimationFrame(step);
}

/**
 * Prepare element to be animated, return function that runs animation
 * @param {HTMLElement} el
 * @return {() => void}
 */
function animateNumbers(el) {
	const text = el.textContent.trim();
	const parsed = text.replace(',', '').replace(/[^\d.]/g, '');
	console.log(parsed)
	if (!parsed) return () => undefined;
	if (Number.isNaN(+parsed)) return () => undefined;

	el.textContent = '0';

	let lang = document.documentElement.lang;
	if (lang === 'pl') lang = 'fr';
	return () => {
		animateValue(0, +parsed, 1000, (value, progress) => {
			const formatted = (progress === 1 ? text : Math.floor(value)).toLocaleString(lang)
			el.textContent = formatted;
			if (text.trim().endsWith(',00')) {
				el.textContent = formatted + ',00';
			}
		});
	};
}